export const WIRE_FILES_CONTAINER_TAG_NAME = 'wire-files-container';
